export interface ParsedSseBlock {
  event: string;
  id: string | null;
  data: string | null;
}

/** Parses one complete SSE block while preserving opaque event IDs. */
export function parseSseBlock(block: string): ParsedSseBlock {
  let event = "message";
  let id: string | null = null;
  const data: string[] = [];
  for (const rawLine of block.split(/\r?\n/)) {
    const line = rawLine.trimEnd();
    if (line.startsWith(":")) continue;
    if (line.startsWith("event:")) {
      event = line.slice("event:".length).trim() || "message";
    } else if (line.startsWith("id:")) {
      const value = line.slice("id:".length).trim();
      id = value || null;
    } else if (line.startsWith("data:")) {
      data.push(line.slice("data:".length).trimStart());
    }
  }
  return { event, id, data: data.length > 0 ? data.join("\n") : null };
}
